var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "mgr-users" },
    [
      _c("el-card", { staticClass: "box-card", attrs: { shadow: "never" } }, [
        _c(
          "div",
          {
            staticClass: "card-header",
            attrs: { slot: "header" },
            slot: "header",
          },
          [
            _c("span", [_vm._v("用户列表")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-header-actions" },
              [
                _c("span", { staticClass: "me" }, [
                  _vm._v("当前登录：" + _vm._s(_vm.me.username || "-")),
                ]),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", loading: _vm.loading },
                    on: { click: _vm.loadUsers },
                  },
                  [_vm._v("刷 新")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", type: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.addVisible = true
                      },
                    },
                  },
                  [_vm._v("添加用户")]
                ),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "mu-table-wrap",
          },
          [
            _c("table", { staticClass: "mu-table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("用户名")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("角色")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("创建时间")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "mu-op" }, [_vm._v("操作")]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.users, function (row) {
                    return _c("tr", { key: row.username }, [
                      _c("td", { attrs: { "data-label": "用户名" } }, [
                        _vm._v(_vm._s(row.username)),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "角色" } }, [
                        _c(
                          "span",
                          {
                            staticClass: "mu-role",
                            class:
                              row.role === "admin"
                                ? "mu-role--admin"
                                : "mu-role--user",
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(
                                  row.role === "admin" ? "管理员" : "用户"
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", { attrs: { "data-label": "创建时间" } }, [
                        _vm._v(_vm._s(_vm.formatTime(row.createTime))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        {
                          staticClass: "mu-op",
                          attrs: { "data-label": "操作" },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "mini",
                                type: "primary",
                                plain: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openPasswordDialog(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  修改密码\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          row.role !== "admin"
                            ? _c(
                                "el-button",
                                {
                                  attrs: {
                                    size: "mini",
                                    type: "danger",
                                    plain: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteUser(row)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  删除\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  !_vm.loading && _vm.users.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          { staticClass: "mu-empty", attrs: { colspan: "4" } },
                          [_vm._v("暂无用户数据")]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "添加用户", visible: _vm.addVisible, width: "420px" },
          on: {
            "update:visible": function ($event) {
              _vm.addVisible = $event
            },
            closed: _vm.resetCreateForm,
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { "label-width": "80px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "用户名" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入用户名", autocomplete: "off" },
                    model: {
                      value: _vm.createForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "username", $$v)
                      },
                      expression: "createForm.username",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "password",
                      "show-password": "",
                      autocomplete: "off",
                      placeholder: "请输入密码",
                    },
                    model: {
                      value: _vm.createForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.createForm, "password", $$v)
                      },
                      expression: "createForm.password",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      model: {
                        value: _vm.createForm.role,
                        callback: function ($$v) {
                          _vm.$set(_vm.createForm, "role", $$v)
                        },
                        expression: "createForm.role",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "用户", value: "user" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "管理员", value: "admin" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.addVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.submitting },
                  on: { click: _vm.createUser },
                },
                [_vm._v("创 建")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("manager-password-dialog", {
        attrs: {
          visible: _vm.pwdVisible,
          username: _vm.pwdTarget,
          "require-old": _vm.pwdTarget === _vm.me.username,
        },
        on: {
          "update:visible": function ($event) {
            _vm.pwdVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }